import { SliderMarks } from 'antd/lib/slider';

type FormatFunction = (value: number) => SliderMarks;

const formatMark: FormatFunction = (value: number) => ({ style: { color: 'white' }, label: value });

const generateSliderMarks = (startValue: number, endValue: number, step = 5, format = formatMark) => {
    const marks = {};

    const firstMark = (startValue < 0 ? Math.ceil(startValue / step) : Math.floor(startValue / step)) * step;

    for (let i = firstMark; i <= endValue; i += step) {
        marks[i] = format(i);
    }

    return marks;
};

export default generateSliderMarks;
export { FormatFunction };
